import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import translations from "./languages";
import { Language } from "consumerhouse-shared";

export type Translation = keyof typeof translations[keyof typeof translations];

export function useLanguage() {
    let { language } = useContext(LanguageContext);
    return (term: Translation) => {
        if (language === "nl_nl") language = "nl";
        let text = translations[language][term];
        if (!text) {
            console.warn(`Translation for '${term}' not found`);
            return term;
        } else {
            return text;
        }
    };
}
